import { type UseQueryResult } from 'react-query';

import { type LazyQueryState, type QueryState } from 'src/core/api/queryState';
import { TypeGuardError } from 'src/core/utils/switchGuard';

/**
 * Utility function to help interop between React Query results and our
 * internal QueryState type.
 */
export const mapQueryResultToQueryState = <TData>(
  queryResult: UseQueryResult<TData>,
): QueryState<TData> => {
  switch (queryResult.status) {
    case 'idle':
    case 'loading':
      return { status: 'loading' };
    case 'error':
      // FIXME: There is no generic error in QueryError type, forcing the query
      //        result one, this seems to work for now but should be improved
      //        (fromFetchError(queryResult.error) might be helpful here, to
      //        be investigated)
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return { status: 'error', error: queryResult.error as any };
    case 'success':
      return { status: 'success', data: queryResult.data };
    default: {
      throw new TypeGuardError(queryResult, 'unknown query state');
    }
  }
};

export const mapQueryResultToLazyQueryState = <TData>(
  queryResult: UseQueryResult<TData>,
): LazyQueryState<TData> => {
  if (queryResult.status === 'idle') {
    return { status: 'idle' };
  }
  return mapQueryResultToQueryState(queryResult);
};
